import PropTypes from 'prop-types';
import React from 'react';

import Strings from '../../Strings';
import {
  DEFAULT_SUPPORT_DOCUMENTS_FOLDER,
  loadSupportDocumentsFolders,
  SUPPORT_DOCUMENTS_BASE,
  SUPPORT_DOCUMENTS_CONSOLE_URL,
} from '../../utils/supportDocuments';
import { CustomSelect } from './JsonSchemaFormComponents';

export default function SupportDocumentsFolderWidget(props) {
  const { value: configuredValue, options, disabled, readonly, schema } = props;
  const [folders, setFolders] = React.useState(null);
  const [failed, setFailed] = React.useState(false);
  const [reload, setReload] = React.useState(0);

  React.useEffect(() => {
    const controller = new AbortController();
    setFolders(null);
    setFailed(false);
    loadSupportDocumentsFolders(controller.signal)
      .then(result => {
        if (!controller.signal.aborted) {
          setFolders(result);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setFailed(true);
        }
      });
    return () => controller.abort();
  }, [reload]);

  const value = configuredValue ?? DEFAULT_SUPPORT_DOCUMENTS_FOLDER;
  const enumOptions = (folders || []).map(folder => ({ label: folder, value: folder }));
  const missing = folders !== null && !folders.includes(value);
  if (!enumOptions.some(option => option.value === value)) {
    enumOptions.unshift({
      value,
      label: missing ? `${value} (${Strings.supportDocuments.folderUnavailable})` : value,
      isDisabled: true,
    });
  }

  return (
    <>
      <CustomSelect
        // Forward the standard RJSF widget properties to the existing select.
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        schema={{
          ...schema,
          description: (
            <>
              {`Folder name under ${SUPPORT_DOCUMENTS_BASE} in the bucket (`}
              <a href={SUPPORT_DOCUMENTS_CONSOLE_URL} target="_blank" rel="noopener noreferrer">
                {SUPPORT_DOCUMENTS_CONSOLE_URL}
              </a>
              )
            </>
          ),
        }}
        value={value}
        options={{ ...options, enumOptions }}
        disabled={disabled || readonly || folders === null || folders.length === 0}
      />
      {folders === null && !failed && <p role="status">{Strings.loading}</p>}
      {failed && <p role="alert">{Strings.supportDocuments.foldersLoadFailed}</p>}
      {folders?.length === 0 && <p role="status">{Strings.supportDocuments.noFolders}</p>}
      {missing && folders.length > 0 && <p role="status">{Strings.supportDocuments.currentFolderUnavailable}</p>}
      {(failed || folders !== null) && (
        <button type="button" onClick={() => setReload(reload + 1)}>
          {Strings.supportDocuments.refreshFolders}
        </button>
      )}
    </>
  );
}

SupportDocumentsFolderWidget.propTypes = {
  value: PropTypes.string,
  options: PropTypes.object,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  schema: PropTypes.object,
};
